import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy-950 text-silver-200" data-id="element-96" data-mp="3geze367ujv27">
      <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-97" data-mp="3ggk72reij5xy" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-98" data-mp="32onl753ftsa0">
        <p className="metal-text font-serif text-lg font-extrabold uppercase tracking-tight" data-id="element-99" data-mp="36pfutzg81z6t">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-100" data-mp="3ufa64ckw7foy">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-silver-400/25 pt-6 text-xs text-silver-300" data-id="element-101" data-mp="38h2z36jh6hs">
          © 2026 Megapack Criminalística Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}